import React from 'react'
import PropTypes from 'prop-types'
import BEMHelper from '@ynap/bem-helper'
import { Portal } from 'react-portal'
import Overlay from '@ynap/overlay'

const bem = new BEMHelper('PackagingChoices')

const propTypes = {
    onClose: PropTypes.func.isRequired,
    config: PropTypes.shape({
        domain: PropTypes.string,
        links: PropTypes.shape({
            packagingInfo: PropTypes.string,
        }),
    }),
    locale: PropTypes.shape({
        id: PropTypes.string.isRequired,
    }),
}

const PackagingChoices = ({ onClose, config, locale }) => {
    const { links } = config.head
    const { id } = locale

    if (!links.packagingInfo || !id) return null

    // NAP has x-frame-options header set to sameorigin on iframes, so we cant render anything outside.
    // Coremedia page should be available on int and prod environments through editorial
    const src = `/${id}${links.packagingInfo}?bare=true`
    return (
        <Portal>
            <Overlay className={{ container: bem('modal'), content: bem('container') }} onClose={() => onClose(false)} handleBodyClick={() => onClose(false)}>
                <iframe className={bem('iframe')} src={src} />
            </Overlay>
        </Portal>
    )
}

PackagingChoices.propTypes = propTypes

export default PackagingChoices
